const wordReducing = (text) =>
  text.length > 6
    ? `${text.substr(0, 6)}...${text.substr(text.length - 6)}`
    : text;
export default wordReducing;
